import React, { useRef, useState, useEffect } from 'react';

import parse from 'html-react-parser';
import generateKey from '../../../shared/utils/generateKey';

const AccordionItems = [
  {
    title: 'What’s up with all the different choices?',
    content: (
      <>
        Filters are one of the most important components of any air purifier design, and one
        we’ve spent a considerable amount of time optimizing for. Our approach at Mila is to
        give you the right performance for your needs.
        When choosing a filter, it’s important to consider the size of the space, the filter’s overall efficiency,
        and ultimately, the goals you hope
        to achieve.
      </>
    ),
  },
  {
    title: 'How can a filter with higher efficiency have a lower CADR?',
    content: (
      <>
        Every filter has a tradeoff between the level of first pass efficiency (how much it
        filters) and the associated pressure drop (how restricted the airflow becomes). Both
        are crucial to an air purifier’s overall performance but are inversely correlated; as
        filters become more efficient, the filter media becomes more restrictive, which forces
        air to work harder to flow through. This reduces the volume of air that can be filtered
        over a given amount of time, which affects the size of room they can effectively filter.
        For example, a brick wall is a 100% efficient filter that will give you a CADR of 0.
      </>
    ),
  },
  {
    title: 'What the heck is a VOC?',
    content: (
      <>
        Volatile organic compounds (VOCs) are compounds that easily become vapors or
        gasses. They are released from burning fossil fuels as well as outgassing from
        consumer products, plastics, paints, furnitures, carpets, etc. However, studies have
        shown that up to 60% of indoor VOCs are emitted by humans (from your breath,
        sweat and personal care products). A simple rule is if you can smell it ... it’s a VOC :).
        HEPA filters are designed to filter ultra-fine particulates - not gasses. The best media
        for filtering VOCs and odors, or “gas-phase filtration”, has consistently proven to be
        granular activated carbon. It “absorbs” the VOCs onto the surface of the media.
        Consumer-grade VOC sensors are unfortunately still not precise enough to detect what the exact
        VOC chemical is, they only can detect “something” is there.
      </>
    ),
  },
  {
    title: 'How did you run your filter tests?',
    content: (
      <>
        Our VOC tests are done over 60 minute intervals in a 1,059-cubic-feet (30 m
        <sup>3</sup>
        ) test
        chamber (using the GBT 18883-2002 standard). The “TVOC Removal Rate” (Total
        VOC Removal Rate) includes all 9 chemicals in the test chamber at the same time but
        we have tested each individually. Our CADR tests are done in 20 minute intervals to determine the
        particulate volume
        each filter can effectively process in a standard 1,008-cubic-foot (28.5 m
        <sup>3</sup>
        ) test
        chamber.
      </>
    ),
  },
  {
    title: 'Where can I purchase standalone Mila filters from?',
    content: (
      <>
        Individual Mila filters can be purchased
        {' '}
        <a href='/buy/filters'>here</a>
        . Any of our seven filters will
        work with your Mila unit.
      </>
    ),
  },
];

const FaqItem = ({ title, content }) => {
  const [ isOpen, setIsOpen ] = useState(false);
  const [ bodyContent, setBodyContent ] = useState(content);
  const accordionBody = useRef(null);

  const onClick = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    setBodyContent(!isOpen ? parse(`${accordionBody.current.innerHTML.substr(0, 125)}...`) : content);
  }, [ isOpen ]);

  return (
    <li className='faq-accordion'>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <div
        key={generateKey('faq-accordion__header')}
        className={`faq-accordion__header ${isOpen ? 'faq-accordion--is-active' : ''}`}
        onClick={onClick}
      >
        <h3>
          {title}
          <svg className='icon icon-down-arrow-thin'>
            <use xlinkHref='#icon-down-arrow-thin' />
          </svg>
        </h3>
      </div>
      <p
        key={generateKey('faq-accordion__body')}
        className='faq-accordion__body'
        ref={accordionBody}
      >
        {bodyContent}
      </p>
    </li>
  );
};

const FaqBlock = () => (
  <section className='faq-block'>
    <div className='container'>
      <h2 className='faq-block__title'>FAQs for geeks.</h2>
      <ul className='faq-block__list'>
        {AccordionItems.map(item => (
          <FaqItem title={item.title} content={item.content} />
        ))}
      </ul>
    </div>
  </section>
);

export default FaqBlock;
